import { useEffect } from 'react'

import { BrowserLocalstorage } from '../store'

export const useEnvironment = () => {
    useEffect(() => {
        const env = BrowserLocalstorage.getEnvironment()
        if (!env) {
            BrowserLocalstorage.setEnvironment('prod')
        }
    }, [])
}
